import { AppBar, Box, Button, Grid2, Toolbar, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { Loader, Product, ProductFilters } from 'components';
import { routes } from 'constants/';
import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import backV1 from 'assets/images/backV1.svg';
import { useUserSearchContext } from 'context/UserSearchContext';
import { toast } from 'react-toastify';
import { Vehicle } from 'types/products';
import { useMediaQuery } from '@mui/material';
import { useGetVehicles } from 'hooks/useBooking';

export const Listing: React.FC = () => {
  const navigate = useNavigate();
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  if (!id) {
    navigate(-1);
  }
  const {
    data: vehicles,
    error: getVehicleError,
    isLoading,
  } = useGetVehicles(id!);

  if (!isLoading && !vehicles?.data?.SearchVehicleModels?.length) {
    navigate('/search/spot-rental');
    return null;
  }
  const { bookingSearchData, setBookingSearchData } = useUserSearchContext();

  const [selectedFilter, setSelectedFilter] = useState<string>('all');

  const vehiclesData: Vehicle[] = useMemo(() => {
    if (!vehicles?.data?.SearchVehicleModels) return [];
    if (selectedFilter === 'all') return vehicles.data.SearchVehicleModels;

    return vehicles.data.SearchVehicleModels.filter(
      (vehicle: Vehicle) => vehicle.ClassificationId === selectedFilter
    );
  }, [vehicles, selectedFilter]);
  const handleBackClick = () => {
    navigate(-1);
  };

  const addToCart = (product: Vehicle) => {
    const existingVehicleId = bookingSearchData.VehicleModel.VehicleId;

    const redirectRoute = searchParams.get('locationCode')
      ? `${routes.vehicleDetail}?vId=${product.VehicleId}&id=${vehicles.data.ValidateData.Id}&locationCode=${searchParams.get('locationCode')}`
      : `${routes.vehicleDetail}?vId=${product.VehicleId}&id=${vehicles.data.ValidateData.Id}`;

    // If same vehicle → go to details
    if (existingVehicleId && product.VehicleId === existingVehicleId) {
      navigate(redirectRoute);
      return;
    }

    // Reset charge codes when selecting new vehicle
    // localStorage.removeItem('chargeCodes');

    setBookingSearchData((prev) => ({
      ...prev,
      VehicleModel: {
        VehicleId: product.VehicleId,
        Name: product.Name,
        Code: product.Code,
        ModelYear: product.ModelYear,
        Engine: product.Engine,
        Passengers: product.Passengers,
        AutoTransmission: product.AutoTransmission,
        Doors: product.Doors,
        FuelType: 'Petrol',
        VehicleImage: product.VehicleImage,
        UpgradeDiscount: 0,
      },
    }));
    navigate(redirectRoute);
  };

  if (getVehicleError) {
    toast.error(getVehicleError.message);
    navigate('/search/spot-rental');
    return null;
  }
  if (isLoading) return <Loader />;
  return (
    <Box className="">
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: '#043d60',
          backdropFilter: 'blur(8px)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          height: '200px',
          justifyContent: 'space-evenly',
        }}
      >
        <Toolbar
          sx={{
            width: '90%',
            margin: 'auto',
            padding: '0',
          }}
        >
          <Button onClick={handleBackClick} sx={{ mr: 2 }}>
            <Box
              component="img"
              src={backV1}
              alt="Back button"
              sx={{ width: 100 }}
            />
          </Button>

          <Typography
            className="navbarTitle"
            color="primary"
            component="p"
            sx={{ fontWeight: 500 }}
          >
            {`CHOOSE YOUR `}
            <Box
              component="span"
              sx={{ textDecoration: 'underline', fontWeight: 600 }}
            >
              YOUR CAR
            </Box>
          </Typography>
        </Toolbar>

        {/* Divider below AppBar */}
        <Divider sx={{ backgroundColor: 'lightgray', height: '1px' }} />

        <ProductFilters
          options={vehicles.data && vehicles.data.VehicleTypes}
          selectedValue={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        />
      </AppBar>
      {/* <Divider sx={{ borderColor: '#ffffff66', my: 2 }} /> */}
      <Grid2
        className="listingSection"
        container
        spacing={2}
        sx={{ flexGrow: 1 }}
      >
        {vehiclesData &&
          vehiclesData.length > 0 &&
          vehiclesData.map(
            (product: Vehicle, index: React.Key | null | undefined) => {
              return (
                <Grid2
                  size={{ xs: isPortrait ? 6 : 4 }}
                  key={index}
                  className="product-container"
                  onClick={() => addToCart(product)}
                >
                  <Product data={product} />
                </Grid2>
              );
            }
          )}
      </Grid2>
    </Box>
  );
};
